import { render, staticRenderFns } from "./user-assigned-clients.vue?vue&type=template&id=7796780c&scoped=true&"
import script from "./user-assigned-clients.vue?vue&type=script&lang=ts&"
export * from "./user-assigned-clients.vue?vue&type=script&lang=ts&"
import style0 from "./user-assigned-clients.vue?vue&type=style&index=0&id=7796780c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796780c",
  null
  
)

export default component.exports